<div class="container">
  <div class="content">
    <div class="center-column">
      <img class="nowaccount-logo" alt="NowAccount Logo" />
      <h1 [attr.aria-label]="this.headerText">{{ this.headerText }}</h1>
      <app-serverside-alert></app-serverside-alert>
      <ng-container [formGroup]="form">
        <app-kendo-group-textbox
          inputType="text"
          formControlName1="verifyCodeText1"
          formControlName2="verifyCodeText2"
          formControlName3="verifyCodeText3"
          formControlName4="verifyCodeText4"
          formControlName5="verifyCodeText5"
          formControlName6="verifyCodeText6"
          [parentForm]="form"
          (keyup.enter)="onEnter()"
        ></app-kendo-group-textbox>
      </ng-container>
      <div class="button-wrapper">
        <app-primary-button
          text="{{ this.submitText }}"
          href=""
          [clickEvent]="this.VerifyCode.bind(this)"
          #submitButton
        >
        </app-primary-button>
      </div>
      <div class="button-wrapper">
        <app-stateful-secondary-button
          [text]="this.resendText"
          [clickEvent]="this.resendVerifyCode.bind(this)"
        >
        </app-stateful-secondary-button>
      </div>
    </div>
  </div>
</div>